import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ChatbotWidget from "@/components/ChatbotWidget";
import Home from "@/pages/Home";
import CurriculumList from "@/pages/CurriculumList";
import WeekDetail from "@/pages/WeekDetail";
import Teach from "@/pages/Teach";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import TeacherDashboard from "@/pages/TeacherDashboard";
import StudentDashboard from "@/pages/StudentDashboard";
import GrowLab from "@/pages/GrowLab";
import WaterLab from "@/pages/WaterLab";
import PlantPicker from "@/pages/PlantPicker";
import Pricing from "@/pages/Pricing";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";

function DashboardRoute() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user) {
        if (typeof window !== "undefined") window.location.replace("/login");
        return null;
    }
    return user.role === "teacher" ? <TeacherDashboard /> : <StudentDashboard />;
}

function AppShell() {
    const loc = useLocation();
    if (loc.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <>
            <Nav />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/curriculum" element={<CurriculumList />} />
                <Route path="/curriculum/:id" element={<WeekDetail />} />
                <Route path="/grow-lab" element={<GrowLab />} />
                <Route path="/water-lab" element={<WaterLab />} />
                <Route path="/plant-picker" element={<PlantPicker />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/teach" element={<Teach />} />
                <Route path="/dashboard" element={<DashboardRoute />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
            </Routes>
            <Footer />
            <ChatbotWidget />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <LangProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <AppShell />
                    </BrowserRouter>
                </AuthProvider>
            </LangProvider>
        </div>
    );
}

export default App;
